import axios from 'src/admin-axios';
import Constants from 'src/constants';

export const knowledgebase = {
    namespaced: true,
    state: {
        knowledgeBaseList: [],
        tagsList: [],
        categoryList: [],
        knowledgeBaseDetails: [],
    },
    getters: {
        getKnowledgeBase (state) {
            return state.knowledgeBaseList;
        },
        getTags (state) {
            return state.tagsList;
        },
        getCategory (state) {
            return state.categoryList;
        },
        getKnowledgeBaseDetails (state) {
            return state.knowledgeBaseDetails;
        },
    },
    mutations: {
        setKnowledgeBase (state, data) {
            state.knowledgeBaseList = data;
        },
        setTags (state, data) {
            state.tagsList = data;
        },
        setCategory (state, data) {
            state.categoryList = data;
        },
        setKnowledgeBaseDetails (state, data) {
            state.knowledgeBaseDetails = data;
        },
    },
    actions: {
        async fetchKnowledgebase ({ dispatch, commit }, payload) {
            const url = 'knowledge-bases';
            try {
                const response = await axios.get(url, payload);
                commit('setKnowledgeBase', response.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting the knowledgebase list.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
        async deleteKnowledgebase ({ dispatch }, knowledgeId) {
            const url = `knowledge-bases/${knowledgeId.id}`;
            try {
                await axios.delete(url);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in deleting the Knowledgebase.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async createKnowledgeBase ({ dispatch }, payload) {
            const url = 'knowledge-bases';
            try {
                 await axios.post(url, payload);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in creating your Knowledgebase.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async updateKnowledgeBase ({ dispatch }, payload) {
            const url = `knowledge-bases/${payload.knowledgeId}`;
            try {
                 await axios.put(url, payload);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in creating your Knowledgebase.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async createTag ({ dispatch }, payload) {
            const url = 'tags';
            try {
                 await axios.post(url, payload);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in creating your tags.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
        async fetchTags ({ dispatch, commit }) {
            const url = 'tags/knowledge';
            try {
                const response = await axios.get(url);
                commit('setTags', response.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting the tags list.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
        async createCategory ({ dispatch }, payload) {
            const url = '/blogs/categories';
            try {
                 await axios.post(url, payload);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in creating your category.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
        async fetchCategory ({ dispatch, commit }) {
            const url = '/blog-categories/knowledge';
            try {
                const response = await axios.get(url);
                commit('setCategory', response.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting the category list.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
        async deleteCategory ({ dispatch }, knowledgeId) {
            const url = `blogs/categories/${knowledgeId.id}`;
            try {
                await axios.delete(url);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in deleting the Category.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async fetchKnowledgebaseDetails ({ dispatch, commit }, payload) {
            const url = `knowledge-bases/${payload.slug}`;
            try {
                const response = await axios.get(url);
                commit('setKnowledgeBaseDetails', response.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting the Knowledgebase.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
        async PublishKnowledgeBase ({ dispatch }, payload) {
            const url = `knowledge-bases/${payload.knowledgeId}/publish`;
            try {
                 await axios.put(url, payload);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in Publish.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
    },
};
